@import '../../scss';

:host {
  display: block;
  position: relative;
  @include apply-themes();

  phn-p-button-pure {
    font-size: p-px-to-rem(16px);
    margin: p-px-to-rem(6px);

    @include pds-media-query-min('s') {
      font-size: p-px-to-rem(16px);
      margin: p-px-to-rem(8px);
    }

    @include pds-media-query-min('m') {
      font-size: p-px-to-rem(16px);
    }
  }
}
